import React from "react";

import "./App.css";
import Quiz from "./components/quiz";

/* Component Design :
  Quiz
  form >
    question number
    question
    options
  next Button / submit button
  
  will add Prev button later

  
  
  
  
  
  */

function App() {
  return <Quiz />;
}

export default App;
